import {
  DeviceIdCellContent,
  DevicesSubtitle,
  DeviceTable,
  Panel,
  PanelTitle,
  TableCell,
  TableHead,
  TableHeaderCell,
  TopBadge,
} from "./styled"
import type { TopDevice } from "./types"

interface TopEngagedDevicesTableProps {
  devices: TopDevice[]
}

export const TopEngagedDevicesTable = ({ devices }: TopEngagedDevicesTableProps) => (
  <Panel>
    <PanelTitle>Top Engaged Devices</PanelTitle>
    <DevicesSubtitle>Devices with the highest engagement levels this month</DevicesSubtitle>
    <DeviceTable>
      <TableHead>
        <tr>
          <TableHeaderCell>Device ID</TableHeaderCell>
          <TableHeaderCell>Clicks on Logo</TableHeaderCell>
          <TableHeaderCell>QR Scans</TableHeaderCell>
        </tr>
      </TableHead>
      <tbody>
        {devices.slice(0, 6).map((device, index) => (
          <tr key={`${device.deviceId}-${index}`}>
            <TableCell>
              <DeviceIdCellContent>
                <span>{device.deviceId}</span>
                {device.isTop ? <TopBadge>Top</TopBadge> : null}
              </DeviceIdCellContent>
            </TableCell>
            <TableCell>{device.clicks}</TableCell>
            <TableCell>{device.scans}</TableCell>
          </tr>
        ))}
      </tbody>
    </DeviceTable>
  </Panel>
)
